export const GET_PAYMENTDAYSBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    paymentDaysBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      paymentDayType
      heading
    }
  }
`;
